import { toIntlLocale } from "./pdf-i18n";
export function getStartDatetime(item) {
    if (item.start_datetime)
        return item.start_datetime;
    if (item.service_slot?.start_datetime)
        return item.service_slot.start_datetime;
    if (item.service_slot?.start_date)
        return item.service_slot.start_date;
    return null;
}
export function getEndDatetime(item) {
    if (item.end_datetime)
        return item.end_datetime;
    if (item.service_slot?.end_datetime)
        return item.service_slot.end_datetime;
    if (item.service_slot?.end_date)
        return item.service_slot.end_date;
    return null;
}
export function formatPdfDate(dateString, locale) {
    if (!dateString)
        return "-";
    const date = new Date(dateString.replace("Z", ""));
    if (Number.isNaN(date.getTime()))
        return "-";
    return date.toLocaleDateString(toIntlLocale(locale), {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
    });
}
export function formatPdfShortDate(dateString, locale) {
    if (!dateString)
        return "-";
    const date = new Date(dateString.replace("Z", ""));
    if (Number.isNaN(date.getTime()))
        return "-";
    return date.toLocaleDateString(toIntlLocale(locale), {
        weekday: "short",
        day: "numeric",
        month: "short",
        year: "numeric",
    });
}
export function formatPdfTime(dateString, locale) {
    if (!dateString)
        return "-";
    const date = new Date(dateString.replace("Z", ""));
    if (Number.isNaN(date.getTime()))
        return "-";
    return date.toLocaleTimeString(toIntlLocale(locale), {
        hour: "2-digit",
        minute: "2-digit",
    });
}
export function formatPdfCurrency(amount) {
    if (amount === null || amount === undefined)
        return "-";
    return `$${Number(amount).toFixed(2)}`;
}
export function formatFieldLabel(key) {
    return key
        .replace(/_/g, " ")
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .replace(/\b\w/g, (character) => character.toUpperCase());
}
